



























































































import { Vue, Component } from "vue-property-decorator";
import api, { importCsvApi } from "@/getinfo-api";
import FileManager from "@/components/files/FileManager.vue";
import { FileItem as IFileItem } from "@/api/models/file-item";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import CustomButton from "@/components/form/CustomButton.vue";

@Component({ components: { CustomButton, FileManager } })
export default class ImportFromCsv extends Vue {
  csvForUsers!: IFileItem;
  popupIsOpen: boolean = false;
  isSavingProcess: boolean = false;
  delimiter?: string;
  errors!: any;

  data() {
    return {
      delimiter: ";",
      csvForUsers: undefined,
      errors: undefined
    };
  }

  openFileManager() {
    this.popupIsOpen = !this.popupIsOpen;
  }
  startImportUsers() {
    if (this.csvForUsers) {
      this.isSavingProcess = true;
      importCsvApi.UserImportApi.importUserCsv(this.selectedCompany.id, {
        fileId: this.csvForUsers.id,
        delimeter: this.delimiter
      })
        .then(res => {
          this.$bvToast.toast(`${this.$tc(this.$translate.Successful)}`, {
            variant: "success",
            title: `${this.$tc(this.$translate.Success)}`
          });
          // localStorage.setItem(
          //   "importedUsers",
          //   JSON.stringify(res.data)
          // );
          this.$router.push({
            name: "ImportView",
            params: { id: res.data.id }
          });
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          if (err?.response) {
            this.errors = err.response.data.message;
            this.$store.dispatch("errorException", {
              vm: this,
              error: err.response
            });
          } else {
            this.$bvToast.toast(
              `${this.$tc(this.$translate.SorrySomethingWentWrong)}`,
              {
                variant: "danger",
                title: `${this.$tc(this.$translate.Error)}`
              }
            );
          }
        })
        .finally(() => {
          this.isSavingProcess = false;
        });
    } else {
      this.$bvToast.toast(`${this.$tc(this.$translate.FileNotSelected)}`, {
        variant: "danger",
        title: `${this.$tc(this.$translate.Error)}`
      });
    }
  }

  getFileForImportUsers(file: IFileItem) {
    if (file.mimeType === "text/csv") {
      this.csvForUsers = file;
      this.popupIsOpen = false;
    } else {
      this.$bvToast.toast(`${this.$tc(this.$translate.YouCanOnlyUseScvFile)}`, {
        variant: "danger",
        title: `${this.$tc(this.$translate.Error)}`
      });
    }
  }

  get selectedCompany() {
    return this.$store.getters.selectedCompany;
  }
}
